import React, { useState, useEffect, useMemo } from 'react';
import message from '@web-common/components/UI/Message/SiriusMessage';
import style from './MailDelivery.module.scss';
import ContactScheduleModal from '@web-common/components/UI/SiriusContact/scheduleModal';
import { apiHolder as api, apis } from 'api';
import { verifyEmail } from '@web-mail-write/util';
import { isMainAccount } from '@web-mail/util';
import cloneDeep from 'lodash/cloneDeep';
import SiriusModal from '@web-common/components/UI/Modal/SiriusModal';
import { MailActions, useAppDispatch } from '@web-common/state/createStore';
import { getIn18Text } from 'api';
const mailApi = api.api.requireLogicalApi(apis.mailApiImpl);
const systemApi = api.api.getSystemApi();
const trackApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
const accountApi = api.api.requireLogicalApi(apis.accountApiImpl);
const MAX_NUM = 500;
const transContactItem2DeliveryBcc = (arr) => {
    const result = arr.map(a => {
        const { email, name } = a || {};
        if (!email) {
            return '';
        }
        return name ? `"${name}" <${email}>` : email;
    });
    return result.filter(s => !!s);
};
export const MailDelivery = (props) => {
    const dispatch = useAppDispatch();
    const { visible, setVisible, mailId, account, way } = props;
    const [errText, setErrText] = useState('');
    const [bcc, setBcc] = useState([]);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        if (visible) {
            setBcc([]);
            setErrText('');
        }
    }, [visible]);
    const handleCancel = () => {
        setVisible(false);
    };
    const handleOk = () => {
        const bccArr = transContactItem2DeliveryBcc(bcc);
        setLoading(true);
        mailApi
            .requestDelivery(mailId, bccArr, account)
            .then(res => {
            if (res === true) {
                message.success(getIn18Text('deliveryMailSuccess'));
                setVisible(false);
                setTimeout(async () => {
                    const result = await mailApi.doListMailBoxEntities({
                        mids: [mailId],
                        count: 1,
                        returnModel: true,
                    }, true);
                    dispatch(MailActions.updateMailEntities({
                        mailList: result.data,
                    }));
                }, 2000);
            }
            else {
                message.error(getIn18Text('deliveryMailFailed'));
            }
            setLoading(false);
        })
            .catch(err => {
            message.error(getIn18Text('deliveryMailFailed'));
            setLoading(false);
        });
        try {
            trackApi.track('waimao_mail_click_distribute', { way });
        }
        catch (error) {
            console.log('[mail delivery] error', error);
        }
    };
    const handleChange = (ContactItemArr) => {
        const value = ContactItemArr.map(c => c.email);
        const valited = Array.isArray(value) && value.reduce((prev, curv) => prev && verifyEmail(curv === null || curv === void 0 ? void 0 : curv.trim()), true);
        const limited = Array.isArray(value) && value.length <= MAX_NUM;
        if (!valited) {
            setErrText(getIn18Text('YOUXIANGGESHICUO1'));
        }
        if (!limited) {
            setErrText(getIn18Text('deliveryMaxNum'));
        }
        if (valited && limited) {
            setErrText('');
        }
        if (ContactItemArr.length <= MAX_NUM) {
            setBcc(ContactItemArr);
        }
        else {
            const bccCp = cloneDeep(ContactItemArr);
            setBcc(bccCp.splice(0, MAX_NUM));
        }
    };
    const useEdm = systemApi.inEdm();
    const treeType = useMemo(() => {
        if (isMainAccount(account)) {
            return undefined;
        }
        const isQy = accountApi.getAccountsEmailType(account) === 'NeteaseQiYeMail';
        if (isQy) {
            return ['personal', 'recent', 'customer', 'enterprise'];
        }
        return ['personal', 'recent', 'customer'];
    }, [account]);
    return (React.createElement(React.Fragment, null,
        React.createElement(SiriusModal, { maskStyle: { top: 0 }, wrapClassName: style.wrap, closable: false, visible: visible, title: getIn18Text('deliveryMailTitle'), onCancel: handleCancel, onOk: handleOk, okButtonProps: { disabled: bcc.length === 0 || loading || errText === getIn18Text('YOUXIANGGESHICUO1') }, cancelButtonProps: { disabled: loading }, okText: getIn18Text('FASONG'), cancelText: getIn18Text('QUXIAO'), width: 480, maskClosable: false, className: style.mailDelivery },
            React.createElement(ContactScheduleModal, { accountRootKey: account, includeSelf: true, useEdm: useEdm, disabled: loading, showClear: true, onChange: handleChange, defaultSelectList: bcc, ceiling: MAX_NUM, type: treeType, placeholder: getIn18Text('deliveryPlaceholder') }),
            errText && React.createElement("span", { className: style.warn }, errText),
            React.createElement("div", { className: style.tip },
                React.createElement("div", null,
                    "1\u3001",
                    getIn18Text('deliveryTip1'),
                    React.createElement("span", { className: style.warn }, getIn18Text('deliveryTip2')),
                    getIn18Text('deliveryTip3'),
                    React.createElement("span", { className: style.warn }, getIn18Text('deliveryTip4'))),
                React.createElement("div", null,
                    "2\u3001",
                    getIn18Text('deliveryTip5'))))));
};
export default MailDelivery;
